import React from 'react';
import { Alert } from 'react-bootstrap';

import Body from '../layoutcredenciamento/Body';
import Footer from '../layoutcredenciamento/Footer';
import Header from '../layoutcredenciamento/Header';
import Layout from '../layoutcredenciamento/Layout';

const EventoNaoEncontrado = () => {
    return (
        <Layout>
            <Header />
            <Body>
                <Alert variant="warning">
                    <Alert.Heading>Desculpe!</Alert.Heading>
                    <Alert variant="warning">Evento não encontrado</Alert>
                </Alert>
            </Body>
            <Footer />
        </Layout>
    );
}

export default EventoNaoEncontrado;